var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTradingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1539",
    "data-name": "Group 1539",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1535",
    "data-name": "Group 1535"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#e30019",
    opacity: 0.182
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "news-paper-svgrepo-com",
    d: "M3.7,11.323H7.215V5.7a.664.664,0,0,1,.7-.7H20.563a.664.664,0,0,1,.7.7V18.348a2.818,2.818,0,0,1-2.81,2.81H6.513a.258.258,0,0,1-.211-.07c-.141,0-.281.07-.492.07A2.818,2.818,0,0,1,3,18.348V12.025A.664.664,0,0,1,3.7,11.323Zm12.646,1.405h1.405a.7.7,0,1,0,0-1.405H16.348a.7.7,0,0,0,0,1.405Zm-2.81-2.81h4.215a.7.7,0,1,0,0-1.405H13.538a.7.7,0,1,0,0,1.405Zm-9.133,8.43A1.409,1.409,0,0,0,5.81,19.753a.891.891,0,0,0,.422-.07h0a1.427,1.427,0,0,0,.843-.843v-.07a.516.516,0,0,0,.141-.422v-5.62H4.405Z",
    transform: "translate(5.867 4.921)",
    fill: "#e30019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTradingIcon);
export default __webpack_public_path__ + "static/media/newTradingIcon.aa7e702f710df717f6764166a10c93d4.svg";
export { ForwardRef as ReactComponent };